import { createApi } from '@reduxjs/toolkit/query/react'
import { setAuth, unsetAuth } from './index'
import { baseQuery } from 'utils/base-query'
import { setNotice } from '../notice'

export type TCheckTokenRequest = { token: string };
export type TCheckTokenResponse = { valid: boolean };

export const apiAuth = createApi({
  reducerPath: 'apiAuth',
  baseQuery: baseQuery,
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    checkToken: builder.mutation<TCheckTokenResponse, TCheckTokenRequest>({
      query: (dto) => ({url: '/auth/check-token', method: 'PUT', body: dto}),
      async onQueryStarted (body, {dispatch, queryFulfilled}) {
        // queryFulfilled реджектится при сетевой ошибке или 5xx. Без catch это
        // был unhandled promise rejection на каждую неудачную попытку логина.
        try {
          const {data} = await queryFulfilled

          if (data.valid) {
            dispatch(setAuth(body))
            dispatch(setNotice({type: 'success', message: 'Successful login!'}))
            return
          }

          dispatch(unsetAuth())
          dispatch(setNotice({type: 'error', message: 'Token invalid!'}))
        } catch {
          // Сообщение об ошибке запроса уже показывает noticeMiddleware.
        }
      }
    })
  })
})

export const {useCheckTokenMutation} = apiAuth
